import { Stack } from '@genial/components';
import React from 'react';

import { useGlobalProductContext } from '../../contexts';

export const ProductList: React.FC = () => {
  const { product } = useGlobalProductContext();

  const SelectedTabProductList = product.principalComponent;

  return (
    <Stack pt="stack.xxs">
      <SelectedTabProductList />
    </Stack>
  );
};
